const defaults = {
  width: "1024",
  format: "jpg&fl=progressive",
  quality: "90"
};

export default (
  url: string,
  width: string = defaults.width,
  format?: string
): string => {
  if (!url) return "";

  if (!format && url) {
    const imageFormat = url.split(".").pop();

    if (imageFormat === "gif") {
      return url;
    }

    const getFormat = imageFormat === "png" ? "png" : defaults.format;

    return `${url}?w=${width}&fm=${getFormat}&q=90`;
  }

  return `${url}?w=${width}&fm=${format || defaults.format}&q=90`;
};
